import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '../lib/cn';
const alertVariants = cva('relative w-full rounded-lg border px-4 py-3 text-sm [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-7', {
    variants: {
        variant: {
            default: 'bg-background text-foreground',
            destructive: 'border-destructive/50 bg-destructive/5 text-destructive [&>svg]:text-destructive',
            success: 'border-success/40 bg-success/10 text-success [&>svg]:text-success',
            // A half-success must not render as a success. `EVT-025` AC-5's bulk report is the first
            // caller: six of nine cancelled is neither green nor red, and giving it `default` would
            // put it in the same colour as a clean run — which is the colour that gets read at a door.
            warning: 'border-warning/40 bg-warning/10 text-warning [&>svg]:text-warning',
        },
    },
    defaultVariants: { variant: 'default' },
});
export const Alert = React.forwardRef(({ className, variant, ...props }, ref) => (_jsx("div", { ref: ref, role: "alert", className: cn(alertVariants({ variant }), className), ...props })));
Alert.displayName = 'Alert';
export const AlertTitle = React.forwardRef(({ className, children, ...props }, ref) => (_jsx("h5", { ref: ref, className: cn('mb-1 font-medium leading-none tracking-tight', className), ...props, children: children })));
AlertTitle.displayName = 'AlertTitle';
export const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('text-sm [&_p]:leading-relaxed', className), ...props })));
AlertDescription.displayName = 'AlertDescription';
//# sourceMappingURL=alert.js.map